import { watch } from 'vue'
import { inputValoriDeVerificat } from '../../../../src/constante.js'

export function useFormValidation(formData) {
    // Determine interval class based on value and sex
    const clasaIntervalValori = (element, val, sex) => {
        let classClass = null
        let lastIndex, keys, subAttr

        if (sex === 'M') {
            subAttr = 'claseM'
        } else if (sex === 'F') {
            subAttr = 'claseF'
        } else {
            return null
        }

        if (!inputValoriDeVerificat[element] || !inputValoriDeVerificat[element][subAttr]) {
            return null
        }

        keys = Object.keys(inputValoriDeVerificat[element][subAttr])
        lastIndex = keys.length - 1

        for (let scale in inputValoriDeVerificat[element][subAttr]) {
            if (val <= parseFloat(scale)) {
                classClass = inputValoriDeVerificat[element][subAttr][scale]
                break
            }
        }

        // Setting the last index scale's class since we reached the end
        if (!classClass) {
            classClass = inputValoriDeVerificat[element][subAttr][keys[lastIndex]]
        }

        return classClass
    }

    // Verify value against intervals and return classification
    const verificaIntervalValori = (fieldName, value, sex) => {
        if (!value || !sex) return null

        const val = parseFloat(value)
        if (isNaN(val)) return null

        return clasaIntervalValori(fieldName, val, sex)
    }

    // Get CSS class for a field based on validation
    const getValidationClass = (fieldName) => {
        if (!formData[fieldName]) return ''

        const value = formData[fieldName].value
        const sex = formData.sexPacient?.value

        if (!value || !sex) return ''

        const classClass = verificaIntervalValori(fieldName, value, sex)
        return classClass || ''
    }

    // Setup watchers for all validated fields
    const setupValidationWatchers = () => {
        Object.keys(inputValoriDeVerificat).forEach(fieldName => {
            if (formData[fieldName]) {
                watch([() => formData[fieldName].value, () => formData.sexPacient?.value], () => {
                    const validation = getValidationClass(fieldName)
                })
            }
        })
    }

    setupValidationWatchers()

    return {
        clasaIntervalValori,
        verificaIntervalValori,
        getValidationClass
    }
}
